import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EDIT_INFO_FEATURE_KEY, EditInfoState } from './edit-info.reducer';

// Lookup the 'EditInfo' feature state managed by NgRx
export const getEditInfoState = createFeatureSelector<EditInfoState>(
  EDIT_INFO_FEATURE_KEY,
);

export const isSaving = createSelector(
  getEditInfoState,
  (state: EditInfoState) => state.saving,
);

export const getEditInfoError = createSelector(
  getEditInfoState,
  (state: EditInfoState) => state.error,
);
